import React, { useState } from "react"
import { Modal, Button } from "react-bootstrap"
import { SystemNotificationDocument, UserId } from "popopo-msg"
import { QuillViewer } from "popopo-lib-front/component"
import { markSystemNotificationAsSeenLaunchPopup } from "popopo-lib-front/firestore-access"
import { firestore } from "../core"
import { formatDateTime } from "../lib/util"
import { useToast } from "popopo-lib-front/hook"

type Props = {
  notification: SystemNotificationDocument
  show: boolean
  userId: UserId
  onClose: () => void
}

export function LaunchPopup({ notification, show, userId, onClose }: Props) {
  const [isMarkingRead, setIsMarkingRead] = useState(false)
  const toast = useToast()

  const handleMarkAsRead = async () => {
    setIsMarkingRead(true)
    try {
      await markSystemNotificationAsSeenLaunchPopup(firestore, userId, notification.id)
      onClose()
    } catch (e) {
      console.error("Failed to mark notification as seen launch popup:", e)
      toast.add({ type: "danger", title: "お知らせ", message: "既読マークに失敗しました" })
    } finally {
      setIsMarkingRead(false)
    }
  }

  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="fas fa-bell me-2"></i>
          起動時お知らせ
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <h5>{notification.title}</h5>
          <small className="text-muted">
            投稿日時: {formatDateTime(notification.display_period.start_at)}
          </small>
        </div>
        <div className="quill-content">
          <QuillViewer content={notification.content} />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          そのまま閉じる
        </Button>
        <Button 
          variant="primary" 
          onClick={handleMarkAsRead}
          disabled={isMarkingRead}
        >
          {isMarkingRead ? (
            <>
              <i className="fas fa-spinner fa-spin me-1"></i>
              処理中...
            </>
          ) : (
            "既読にする"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}